import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useSetUserPrivacyAgreedMutation as UseSetUserPrivacyAgreedMutation,
  type useSetUserPrivacyAgreedMutation$data
} from '@/__generated__/useSetUserPrivacyAgreedMutation.graphql'

type CommitAsyncFn = () => Promise<useSetUserPrivacyAgreedMutation$data>

export const useSetUserPrivacyAgreedMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseSetUserPrivacyAgreedMutation>(graphql`
    mutation useSetUserPrivacyAgreedMutation($input: SetUserPrivacyAgreedInput!) {
      setUserPrivacyAgreed(input: $input) {
        clientMutationId
        user {
          privacyAgreedAt
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    () =>
      new Promise<useSetUserPrivacyAgreedMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          // transport-level failures (offline, 5xx, WS drop) invoke onError, not onCompleted — without
          // this the promise would never settle and the caller would hang forever.
          onError: (error) => reject(error),
          variables: {
            input: {
              clientMutationId: 'setUserPrivacyAgreed'
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
